/* Photo selection and framing are independent of pricing and engraving data. */
(function (scope) {
  function select(library, board, variant, back = false) {
    if (!library || !variant) return null;
    let source = variant;
    if (back) {
      // A front-side groove must never appear on the reverse. Keep cutout
      // handles, but add underside pockets/feet separately as layout guides.
      const handles = ['Pocket', 'Side'].includes(variant.handles) ? 'None' : variant.handles;
      source = board.variant.find(v => v.wood === variant.wood && v.groove === 'None' && v.handles === handles);
      if (!source) return null;
    }
    const entry = library.skus[source.sku];
    const photo = entry && library.photos[entry.asset];
    if (!photo) return null;
    const [x, y, width, height] = photo.bounds;
    if (!(width > 0 && height > 0 && photo.width > 0 && photo.height > 0)) return null;
    return { ...entry, ...photo, sku: source.sku, ratio: width / height,
      frame: { left: -x / width * 100, top: -y / height * 100,
        width: photo.width / width * 100, height: photo.height / height * 100 } };
  }
  const api = { select };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else scope.RefineDesignerPhotos = api;
})(typeof window !== 'undefined' ? window : globalThis);
